export function setHeaderGhost(ghost) {
  return {
    type: 'SET_HEADER_GHOST',
    payload: ghost
  };
}
